import classNames from "classnames";
import { Typography } from "neetoui";
import { useTranslation } from "react-i18next";

const ExpiryNotice = ({ expiryConfiguration }) => {
  const { t } = useTranslation();
  const { daysBeforeExpiry } = expiryConfiguration;

  let notice = t("neetoMolecules.shareViaLink.expiryNotice.daysRemaining", {
    count: daysBeforeExpiry,
  });
  if (daysBeforeExpiry < 1) {
    notice = t("neetoMolecules.shareViaLink.expiryNotice.expiresToday");
  }

  if (daysBeforeExpiry <= 0) {
    notice = t("neetoMolecules.shareViaLink.expiryNotice.expired");
  }

  return (
    <Typography
      data-testid="expiry-notice"
      lineHeight="normal"
      style="body3"
      className={classNames("ms-1", {
        "neeto-ui-text-error-800": daysBeforeExpiry <= 1,
        "neeto-ui-text-gray-700": daysBeforeExpiry > 1,
      })}
    >
      {notice}
    </Typography>
  );
};

export default ExpiryNotice;
